import React from 'react';
import './style.css';

export default class ConfirmComponent extends React.Component {
    state = {
        animating: false,
    }

    closeModal = () => {
        this.setState({animating: true})
        setTimeout(() => {
            this.setState({animating: false});
            this.props.close();
        }, 250)
    }

    onSubmit = () => {
        this.props.onSubmit();
        this.closeModal();
    }

    render() {
        let clases = ["modal"]

        if(this.state.animating)
            clases.push("animating")
        if(this.props.isActive)
            clases.push("is-active")

        return (
            <div className="Confirm">
                <div className={clases.join(" ")}>
                    <div className="modal-background"></div>
                    <div className="modal-card">
                        <header className="modal-card-head">
                            <p className="modal-card-title">{this.props.header}</p>
                        </header>
                        <section className="modal-card-body">
                            <p>{this.props.text}</p>
                        </section>
                        <footer className="modal-card-foot">
                            <button onClick={this.onSubmit} className="button is-danger">Aceptar</button>
                            <button onClick={this.closeModal} className="button">Cancelar</button>
                        </footer>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/confirm/index.js